import React from 'react';

import Typography from '@material-ui/core/Typography'

import MemberTimesheetsContent from './MemberTimesheetsContent';
import MemberMiniMenu from '../menus/MemberMiniMenu';

const MemberTimesheetsPage = () => {
    return (
        <MemberMiniMenu>
            <Typography variant="h6" color="initial">Invoices</Typography>
            <MemberTimesheetsContent layout="grid" />
        </MemberMiniMenu>
    )
};

export default MemberTimesheetsPage;